<template>
  <div class="law">
    <back-home-btn></back-home-btn>

    <v-container class="pa-3 pt-5">
      <h2 class="text-h4">利用規約</h2>
      <pre class="text-body-2 py-3">
この利用規約（以下，「本規約」といいます。）は，株式会社今井農園（以下，「当社」といいます。）がこのウェブサイト上で提供するオンラインショップ（以下，「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。</pre
      >
      <v-card class="pa-5">
        <v-row>
          <template v-for="(item, index) in items">
            <v-col
              :key="`title${index}`"
              cols="12"
              class="text-h6 font-weight-bold pb-1"
            >
              {{ item.title }}
            </v-col>
            <v-col :key="`content${index}`" cols="12" class="text-body-2 pt-1">
              <ol v-if="item.type == 'list'">
                <li v-for="c in item.contents" :key="c.number">
                  {{ c.text }}
                  <template>
                    <ul v-for="sc in c.subContents" :key="sc.number">
                      <li>{{ sc.text }}</li>
                    </ul>
                  </template>
                </li>
              </ol>
              <pre v-else class="text-body-2">{{ item.text }}</pre>
            </v-col>
          </template>
          <v-col class="text-end text-body-2">以上</v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import BackHomeBtn from '../components/common/BackHomeBtn.vue';

export default {
  components: {
    BackHomeBtn,
  },
  data: () => ({
    items: [
      {
        title: '第1条（適用）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。',
            subContents: null,
          },
          {
            number: 2,
            text:
              '当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下,「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。',
            subContents: null,
          },
          {
            number: 3,
            text:
              '本規約の定めが前項の個別規定の定めと矛盾する場合には，個別規定において特段の定めなき限り，個別規定の定めが優先されるものとします。',
            subContents: null,
          },
        ],
      },
      {
        title: '第2条（利用登録）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '本サービスにおいては，登録希望者が本規約に同意の上，当社の定める方法によって利用登録を申請し，当社がこれに対する承認を登録希望者に通知することによって，利用登録が完了するものとします。',
            subContents: null,
          },
          {
            number: 2,
            text:
              '当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。',
            subContents: [
              {
                number: 1,
                text: '利用登録の申請に際して虚偽の事項を届け出た場合',
              },
              {
                number: 2,
                text: '本規約に違反したことがある者からの申請である場合',
              },
              {
                number: 3,
                text: 'その他，当社が利用登録を相当でないと判断した場合',
              },
            ],
          },
        ],
      },
      {
        title: '第3条（メールアドレスおよびパスワードの管理）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              'ユーザーは，自己の責任において，本サービスのメールアドレスおよびパスワードを管理するものとします。',
            subContents: null,
          },
          {
            number: 2,
            text:
              'ユーザーは，いかなる場合にも，メールアドレスおよびパスワードを第三者に譲渡または貸与し，もしくは第三者と共用することはできません。当社は，メールアドレスとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのメールアドレスを登録しているユーザー自身による利用とみなします。',
            subContents: null,
          },
          {
            number: 3,
            text:
              'メールアドレス及びパスワードが第三者に使用されたことによって生じた損害は，当社に故意又は重大な過失がある場合を除き，当社は一切の責任を負わないものとします。',
            subContents: null,
          },
        ],
      },
      {
        title: '第4条（売買契約）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '本サービスにおいては，ユーザーが当社に対して購入の申し込みをし，これに対して当社が当該申し込みを承諾した旨の通知をすることによって売買契約が成立するものとします。なお，当該商品の所有権は，当社が商品を配送業者に引き渡したときに，ユーザーに移転するものとします。',
            subContents: null,
          },
          {
            number: 2,
            text:
              '当社は，ユーザーが以下のいずれかの事由に該当する場合には，当該ユーザーに事前に通知することなく，前項の売買契約を解除することができるものとします。',
            subContents: [
              { number: 1, text: 'ユーザーが本規約に違反した場合' },
              {
                number: 2,
                text: '届け先不明や長期の不在のため商品の配送が完了しない場合',
              },
              {
                number: 3,
                text: 'その他当社とユーザーの信頼関係が損なわれたと認める場合',
              },
            ],
          },
          {
            number: 3,
            text:
              '本サービスに関する決済方法，配送方法，購入の申し込みのキャンセル方法，または返品方法等については，別途当社が定める方法によります。',
            subContents: null,
          },
        ],
      },
      {
        title: '第5条（知的財産権）',
        type: 'text',
        text:
          '本サービスによって提供される商品写真その他のコンテンツ（以下「コンテンツ」といいます）の著作権又はその他の知的所有権は,当社及びコンテンツ提供者などの正当な権利者に帰属し,ユーザーは,これらを無断で複製,転載,改変,その他の二次利用をすることはできません。',
      },
      {
        title: '第6条（禁止事項）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              'ユーザーは，本サービスの利用にあたり，以下の行為をしてはならないものとします。',
            subContents: [
              { number: 1, text: '法令または公序良俗に違反する行為' },
              { number: 2, text: '犯罪行為に関連する行為' },
              {
                number: 3,
                text:
                  '本サービスに含まれる著作権，商標権その他の知的財産権を侵害する行為',
              },
              {
                number: 4,
                text:
                  '当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為',
              },
              {
                number: 5,
                text: '本サービスによって得られた情報を商業的に利用する行為',
              },
              {
                number: 6,
                text: '当社のサービスの運営を妨害するおそれのある行為',
              },
              { number: 7, text: '不正アクセスをし，またはこれを試みる行為' },
              {
                number: 8,
                text: '他のユーザーに関する個人情報等を収集または蓄積する行為',
              },
              { number: 9, text: '他のユーザーに成りすます行為' },
              {
                number: 10,
                text:
                  '当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為',
              },
              { number: 11, text: 'その他，当社が不適切と判断する行為' },
            ],
          },
        ],
      },
      {
        title: '第7条（本サービスの提供の停止等）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。',
            subContents: [
              {
                number: 1,
                text:
                  '本サービスにかかるコンピュータシステムの保守点検または更新を行う場合',
              },
              {
                number: 2,
                text:
                  '地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合',
              },
              {
                number: 3,
                text: 'コンピュータまたは通信回線等が事故により停止した場合',
              },
              {
                number: 4,
                text: 'その他，当社が本サービスの提供が困難と判断した場合',
              },
            ],
          },
          {
            number: 2,
            text:
              '当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。',
            subContents: null,
          },
        ],
      },
      {
        title: '第8条（利用制限および登録抹消）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '当社は，以下のいずれかに該当する場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。',
            subContents: [
              { number: 1, text: '本規約のいずれかの条項に違反した場合' },
              {
                number: 2,
                text: '登録事項に虚偽の事実があることが判明した場合',
              },
              {
                number: 3,
                text:
                  '決済手段として当該ユーザーが届け出たクレジットカードが利用停止となった場合',
              },
              { number: 4, text: '料金等の支払債務の不履行があった場合' },
              {
                number: 5,
                text: '当社からの連絡に対し，一定期間返答がない場合',
              },
              {
                number: 6,
                text:
                  '本サービスについて，最終の利用から一定期間利用がない場合',
              },
              {
                number: 7,
                text:
                  'その他，当社が本サービスの利用を適当でないと判断した場合',
              },
            ],
          },
          {
            number: 2,
            text:
              '当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。',
            subContents: null,
          },
        ],
      },
      {
        title: '第9条（退会）',
        type: 'text',
        text:
          'ユーザーは，所定の退会手続により，本サービスから退会できるものとします。',
      },
      {
        title: '第10条（保証の否認および免責事項）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '当社は,本サービスに事実上または法律上の瑕疵（安全性,信頼性,正確性,完全性,有効性,特定の目的への適合性,セキュリティなどに関する欠陥,エラーやバグ,権利侵害などを含みます。）がないことを保証するものではありません。',
            subContents: null,
          },
          {
            number: 2,
            text:
              '当社は,本サービスによってユーザーに生じたあらゆる損害について,一切の責任を負いません。ただし,本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合,この免責規定は適用されませんが,この場合であっても,当社は,当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し,または予見し得た場合を含みます。）について一切の責任を負いません。',
            subContents: null,
          },
          {
            number: 3,
            text:
              '当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。',
            subContents: null,
          },
        ],
      },
      {
        title: '第11条（サービス内容の変更等）',
        type: 'text',
        text:
          '当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。',
      },
      {
        title: '第12条（利用規約の変更）',
        type: 'text',
        text:
          '当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお，本規約の変更後，本サービスの利用を開始した場合には，当該ユーザーは変更後の規約に同意したものとみなします。',
      },
      {
        title: '第13条（個人情報の取扱い）',
        type: 'text',
        text:
          '当社は，本サービスの利用によって取得する個人情報については，商品の発送または本サービスの提供に必要な連絡にのみ使用するものとします。',
      },
      {
        title: '第14条（通知または連絡）',
        type: 'text',
        text:
          'ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。当社は,ユーザーから,当社が別途定める方式に従った変更届け出がない限り,現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い,これらは,発信時にユーザーへ到達したものとみなします。',
      },
      {
        title: '第15条（権利義務の譲渡の禁止）',
        type: 'text',
        text:
          'ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。',
      },
      {
        title: '第16条（準拠法・裁判管轄）',
        type: 'list',
        contents: [
          {
            number: 1,
            text:
              '本規約の解釈にあたっては，日本法を準拠法とします。なお，本サービスに関しては，国際物品売買契約に関する国際連合条約の適用を排除するものとします。',
            subContents: null,
          },
          {
            number: 2,
            text:
              '本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。',
            subContents: null,
          },
        ],
      },
    ],
  }),
};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>
